import { TApplicationState } from '../../types/redux';

export function showOrderTooltipSelector(state: TApplicationState) {
  return state.flatViewOrder.showTooltip;
}
